import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, SuepChangeModelModalAliases } from '../../codegen';
import BaseController from '../BaseController';
import {SuepModelService} from './suep-model-service';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

@Controller({ fragment: FragmentNames.SUEP_CHANGE_MODEL_MODAL })
export default class SuepChangeModelModalController extends BaseController {

  @OnMount({ target: SuepChangeModelModalAliases.LAYOUT_CHANGE_MODEL })
  onLayoutMount(): void {
    const { encounterId, patientId, suepId } = this.historyService.getCurrentRouteParams();
    this.context.set({ encounterId, patientId, suepId });
  }

  @OnClick(SuepChangeModelModalAliases.DECK_MODAL_OPTIONS)
  handleClickCard(event: ClickEvent): void {
    const { modelSuepSequence } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    SuepModelService.currentModel = modelSuepSequence;
    applicationContext.redirect(
      ApplicationRoute.MODULE_ELECTRONIC_PATIENT_CHART, {
        encounterId,
        patientId,
      }
    )
  }

}

